/**
 * suggestedPrompts — catálogo CURADO de sugerencias para el empty-state del chat de
 * Paulina (FIX B). Cada chip muestra `label` (texto corto y accionable que ve el
 * comercio) y envía `prompt` (el mensaje real que recibe Paulina).
 *
 * v1 deliberadamente SIMPLE: lista fija, no contextual por página. Catálogo 100%
 * self-service — cosas que Paulina resuelve sola (ver mis pedidos, revisar el menú,
 * horarios, recibir más pedidos, activar el cobro en línea). NO incluye "hablar con
 * soporte" (contradice el propósito de quitarle trabajo a soporte) ni chips que presuman
 * estado del negocio. Mantenerla corta (~5-6) para no abrumar el saludo.
 */

export interface SuggestedPrompt {
  /** Texto visible en el chip (corto, orientado a la acción del comercio). */
  label: string;
  /** Mensaje que se envía a Paulina al hacer click. */
  prompt: string;
}

export const SUGGESTED_PROMPTS: readonly SuggestedPrompt[] = [
  { label: 'Ver mis pedidos de hoy', prompt: '¿cuántos pedidos llevo hoy?' },
  { label: 'Revisar mi menú', prompt: 'revisa mi menú' },
  { label: '¿Cómo cambio mis horarios?', prompt: '¿cómo cambio mis horarios?' },
  { label: '¿Cómo recibo más pedidos?', prompt: '¿cómo puedo recibir más pedidos?' },
  { label: '¿Cómo activo el cobro en línea?', prompt: '¿cómo activo el cobro en línea?' },
];
